import {i18nMixin} from '@/modules/neodash/mixins';
import {VirtualAreasEnum} from '@/modules/neodash/model/types/enums/virtualAreasEnum';

interface LocationType {
  virtualAreaType: number;
  name: string;
}

const freeArea = 'FreeArea';
const actingArea = 'ActingArea';
const contractualArea = 'ContractualArea';
const delimitedArea = 'DelimitedArea';
const influencedArea = 'InfluencedArea';
const operationalAreas = 'OperationalAreas';
const operationalArea = 'OperationalArea';
const salesOperationalAreas = 'SalesOperationalAreas';
const salesCentrality = 'SalesCentrality';
const district = 'District';
const bordering = 'Bordering';
const microRegion = 'MicroRegion';
const mva = 'Mva';
const normalizedRegion = 'NormalizedRegion';
const normalizedRegional = 'NormalizedRegional';
const brazilRegional = 'BrazilRegional';
const plate = 'Plate';
const regionals = 'Regionals';
const regional = 'Regional';
const regions = 'Regions';
const region = 'Region';

const translator = i18nMixin.methods.i18n;

export class ConstantsVirtualArea {
  public static readonly idFreeArea = -37; //Fake area, should use only on Front App

  public static getNameVirtualArea = (id: number): string => {
    // TODO: Review this code, because always when register new area it's necessary register here too. BED SMELL!
    if (!ConstantsVirtualArea.listLabelVirtualAreas.some(x => x.virtualAreaType === id))
      throw new Error('Name Area Virtual not found please register on constants/locationType.ts');

    const virtualArea = ConstantsVirtualArea.listLabelVirtualAreas.findOrFirst(x => x.virtualAreaType === id);

    return translator(`Filters.LocationType.${virtualArea.name}`);
  };

  private static readonly listLabelVirtualAreas: LocationType[] = [
    {virtualAreaType: ConstantsVirtualArea.idFreeArea, name: freeArea},
    {virtualAreaType: -1, name: bordering},
    {virtualAreaType: VirtualAreasEnum.ToyotaSalesOperationalArea, name: salesOperationalAreas},
    {virtualAreaType: VirtualAreasEnum.ToyotaRegions, name: regions},
    {virtualAreaType: VirtualAreasEnum.ToyotaDelimitedArea, name: delimitedArea},
    {virtualAreaType: 4, name: operationalAreas},
    {virtualAreaType: 5, name: mva},
    {virtualAreaType: 6, name: salesCentrality},
    {virtualAreaType: 7, name: operationalAreas},
    {virtualAreaType: 8, name: normalizedRegion},
    {virtualAreaType: 9, name: normalizedRegional},
    {virtualAreaType: 10, name: operationalAreas},
    {virtualAreaType: 11, name: regionals},
    {virtualAreaType: VirtualAreasEnum.ToyotaRegionals, name: regionals},
    {virtualAreaType: 17, name: microRegion},
    {virtualAreaType: 18, name: salesCentrality},
    {virtualAreaType: 19, name: operationalAreas},
    {virtualAreaType: 20, name: operationalAreas},
    {virtualAreaType: 21, name: regional},
    {virtualAreaType: 22, name: operationalArea},
    {virtualAreaType: 23, name: brazilRegional},
    {virtualAreaType: 24, name: regional},
    {virtualAreaType: VirtualAreasEnum.FordInfluencedArea, name: influencedArea},
    {virtualAreaType: 26, name: operationalAreas},
    {virtualAreaType: 27, name: regional},
    {virtualAreaType: 28, name: plate},
    {virtualAreaType: 29, name: contractualArea},
    {virtualAreaType: VirtualAreasEnum.MitsubishiOperationalAreas, name: operationalAreas},
    {virtualAreaType: 31, name: operationalAreas},
    {virtualAreaType: VirtualAreasEnum.MitsubishiActingArea, name: actingArea},
    {virtualAreaType: 33, name: actingArea},
    {virtualAreaType: 34, name: region},
    {virtualAreaType: 35, name: district},
    {virtualAreaType: 36, name: regional},
    {virtualAreaType: 37, name: operationalAreas},
  {virtualAreaType: 63, name: regional}
  ];
}



